export default {
  title: '短信模板',

  // 表单相关
  form: {
    tempName: '模板名称',
    tempNamePlaceholder: '请输入模板名称',
    country: '国家',
    countryPlaceholder: '请选择国家',
    category: '分类',
    categoryPlaceholder: '请选择分类',
    channel: '通道',
    channelPlaceholder: '请选择通道',
    provider: '运营商',
    providerPlaceholder: '请选择运营商',
    status: '状态',
    statusPlaceholder: '请选择状态',
    content: '模板内容',
    contentPlaceholder: '请输入模板内容，支持变量：{username}/{vip_level}/{kyc_name}/{nickname}/{promo_pool_id}/{user_points}/{phone_number}',
    shortChain: '短链',
    shortChainPlaceholder: '请输入短链（可选）',
    agentCode: '代理码',
    agentCodePlaceholder: '请输入代理码（可选）',
    loginChannel: '登录终端',
    loginChannelPlaceholder: '请选择'
  },

  // 国家相关
  country: {
    PH: '菲律宾',
    VN: '越南',
    CN: '中国',
    US: '美国'
  },

  // 表格相关
  table: {
    tempName: '模板名称',
    country: '国家',
    category: '分类',
    channel: '通道',
    provider: '供应商',
    content: '模板内容',
    loginChannel: '登录终端',
    status: '状态',
    actions: '操作'
  },

  // 状态相关
  status: {
    enabled: '启用',
    disabled: '禁用'
  },

  // 按钮相关
  button: {
    create: '新建模板',
    manageCategory: '管理分类',
    test: '测试发送'
  },

  // 弹窗相关
  modal: {
    createTitle: '新建短信模板',
    editTitle: '编辑短信模板'
  },

  // 模板变量相关
  variables: {
    title: '支持的模板变量',
    tip: '点击变量可插入到模板内容中',
    username: '用户名（为空则置空）',
    vipLevel: 'VIP等级（如VIP3）',
    kycName: 'KYC姓名（通过后可用）',
    nickname: '昵称（为空则置空）',
    promoPool: '兑奖码池（如{promo_pool_7788833399}）',
    userPoints: '用户积分余额（用户积分）',
    phoneNumber: '用户手机号码（脱敏显示）'
  },

  // 验证相关
  validation: {
    tempNameRequired: '请输入模板名称',
    countryRequired: '请选择国家',
    categoryRequired: '请选择分类',
    channelRequired: '请选择通道',
    providerRequired: '请选择运营商',
    contentRequired: '请输入模板内容',
    statusRequired: '请选择状态'
  },

  // 消息相关
  message: {
    queryFailed: '查询失败',
    createSuccess: '创建成功',
    createFailed: '创建失败',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    statusUpdateSuccess: '状态更新成功',
    statusUpdateFailed: '状态更新失败'
  },

  // 确认相关
  confirm: {
    delete: '确定要删除此模板吗？',
    toggleStatus: '确定要切换此模板的状态吗？'
  },

  // 分页相关
  pagination: {
    total: '共 {{total}} 条记录'
  },

  // 测试发送相关
  test: {
    title: '测试发送短信',
    templateName: '模板名称',
    templateContent: '模板内容',
    inputLabel: '接收方',
    inputPlaceholder: '请输入手机号或会员账号',
    inputHint: '系统会自动识别您输入的是手机号还是会员账号',
    send: '发送',
    inputRequired: '请输入手机号或会员账号',
    success: '测试发送成功',
    failed: '测试发送失败',
    error: '测试发送出错',
    userNotFound: '测试用户不在系统内'
  },

  // 分类管理相关
  category: {
    modal: {
      title: '模板分类管理'
    },
    table: {
      id: 'ID',
      name: '分类名称',
      actions: '操作'
    },
    form: {
      namePlaceholder: '请输入分类名称'
    },
    button: {
      create: '新建分类'
    },
    confirm: {
      delete: '确定要删除此分类吗？',
      deleteDesc: '删除后无法恢复，请谨慎操作'
    },
    defaultActivity: '活动',
    defaultReminder: '提醒',
    allCategories: '全部分类',
    nameRequired: '请输入分类名称',
    nameExists: '分类名称已存在',
    queryFailed: '查询分类失败',
    createSuccess: '创建分类成功',
    createFailed: '创建分类失败',
    deleteSuccess: '删除分类成功',
    deleteFailed: '删除分类失败'
  }
};
